import { render } from "./Word.vue?vue&type=template&id=6911c789"
import script from "./Word.vue?vue&type=script&lang=js"
export * from "./Word.vue?vue&type=script&lang=js"

import exportComponent from "/Users/corentin/Documents/Projets/Wordle/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__